import {
  ACCOUNT_LOCKED,
  GENERIC_LOGIN_ERROR,
  INVALID_2FA_CODE,
  INVALID_USER,
  NETWORK_ERROR,
  SERVER_ERROR,
  TOO_MANY_ATTEMPTS,
} from "../properties/properties";

export const isLocalhost = () => {
  const {hostname} = window.location;

  return (
    hostname.includes("localhost") ||
    hostname === "[::1]" ||
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
    hostname.endsWith(".localhost")
  );
};

const API_MESSAGES = {
  "invalid login attempt": INVALID_USER,
  "invalid 2fa code": INVALID_2FA_CODE,
};

export const mapApiMessage = (data) => {
  const message = data && typeof data === "object" && data.message;

  return typeof message === "string"
    ? API_MESSAGES[message.trim().toLowerCase()]
    : undefined;
};

export const getAuthErrorMessage = (error, unauthorizedMessage) => {
  const response = error && error.response;
  const status = response && response.status;
  const apiMessage = mapApiMessage(response && response.data);

  if (apiMessage) return apiMessage;
  if (!status) return NETWORK_ERROR;
  if (status === 401) return unauthorizedMessage;
  if (status === 403) return ACCOUNT_LOCKED;
  if (status === 429) return TOO_MANY_ATTEMPTS;
  if (status >= 500) return SERVER_ERROR;

  return GENERIC_LOGIN_ERROR;
};
